import React from 'react';
import styled from 'styled-components';
import ProgressBar from './ProgressBar';
import themeResponsiveProperty from './responsive/themeResponsiveProperty';

export default ({ percentage }) => (
  <StyledProgressBar percentage={percentage} />
);

const StyledProgressBar = styled(ProgressBar)`
  max-width: ${themeResponsiveProperty('7.5rem', null)};
  padding-top: .75rem;
  font-size: .75rem;
  text-transform: none;
`;
